import React, { useState } from "react";
import { Modal } from "react-bootstrap";

import { useHouseDispatch } from "../../contexts/HouseContext";
import "../ledger/LedgerModal.css";

/**
 * Add a player to the house roster. Mirrors the game's add-member modal
 * (`pages/ledger/AddPlayerModal.jsx`) but without the game context — it just
 * names a new regular. On success the new member is dispatched into house
 * state (so the index list updates) and `onAdded` lets the caller refresh
 * the summary tiles.
 */
export function AddPlayerModal({ show, handleClose, onAdded }) {
    const { addMember } = useHouseDispatch();
    const [error, setError] = useState(null);
    const [pending, setPending] = useState(false);

    const close = () => {
        setError(null);
        handleClose();
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        const name = e.target.elements.name.value.trim();
        if (!name) return;
        setPending(true);
        setError(null);
        try {
            const member = await addMember(name);
            if (onAdded) onAdded(member);
            close();
        } catch (err) {
            setError(err.message || "Couldn't add player");
        }
        setPending(false);
    };

    return (
        <Modal
            show={show}
            onHide={close}
            backdrop="static"
            dialogClassName="lm-dialog"
            backdropClassName="lm-backdrop"
            centered
        >
            <div className="lm-head">
                <div className="lm-head-l">
                    <div className="lm-kicker">New player</div>
                    <h2 className="lm-title">
                        Add a <em>player</em>
                    </h2>
                </div>
                <button
                    type="button"
                    className="lm-close"
                    aria-label="Close"
                    onClick={close}
                >
                    ×
                </button>
            </div>

            <form onSubmit={onSubmit}>
                <div className="lm-body">
                    <span className="lm-l">Player name</span>
                    <label className="amt-input-wrap" style={{ padding: "12px 16px" }}>
                        <input
                            type="text"
                            name="name"
                            className="amt-input"
                            placeholder="e.g. Charlie"
                            autoFocus
                            style={{ fontSize: 18 }}
                            required
                        />
                    </label>
                    {error && <div className="lm-error">{error}</div>}
                </div>

                <div className="lm-foot">
                    <span className="lm-foot-meta">Added to your roster</span>
                    <div className="lm-foot-actions">
                        <button type="button" className="lm-cancel" onClick={close}>
                            Cancel
                        </button>
                        <button type="submit" className="lm-submit" disabled={pending}>
                            {pending ? "Adding…" : "Add player"}
                        </button>
                    </div>
                </div>
            </form>
        </Modal>
    );
}

export default AddPlayerModal;
